import { graphql, useStaticQuery, Link } from "gatsby"
import * as React from "react"
import slugify from "@sindresorhus/slugify"
import { navStyle, navLink, activeLink, container, freePostage, specialLink, specialLinkMobile } from "./navigation.module.css"

export function Navigation({ className }) {
  const {
    allStripeProduct: { productTypes },
    site: { siteMetadata },
  } = useStaticQuery(graphql`
    query {
      allStripeProduct {
        productTypes: distinct(field: metadata___Type)
      }
      site {
        siteMetadata {
          specialShipping
        }
      }
    }
  `)

  const {
    specialShipping,
  } = siteMetadata

  return (
    <div className={container}>
      <nav className={[navStyle, className].join(" ")}>
        <Link
          key="All"
          className={navLink}
          to="/products/"
          activeClassName={activeLink}
        >
          All products
        </Link>
        {productTypes.sort((a, b) => a.length - b.length).map((name) => (
          <Link
            key={name}
            className={navLink}
            to={`/products/${slugify(name)}/`}
            activeClassName={activeLink}
          >
            {name}
          </Link>
        ))}
        <span className={freePostage}><Link to="/policies/shipping">Free postage when you spend £45 or more*</Link>{specialShipping && <span> | <Link to="/policies/shipping" className={specialLink}>Special Shipping Notice</Link></span>}</span>
      </nav>
      {specialShipping && <Link to="/policies/shipping" className={specialLinkMobile}>Special Shipping Notice</Link>}
    </div>
  )
}
